import React from "react";

import {
  Link,
  useLocation
} from "react-router-dom";

// =========================
// ICONS
// =========================

import DashboardIcon
from "@mui/icons-material/Dashboard";

import InventoryIcon
from "@mui/icons-material/Inventory";

import ShoppingCartIcon
from "@mui/icons-material/ShoppingCart";

import PeopleIcon
from "@mui/icons-material/People";

import CategoryIcon
from "@mui/icons-material/Category";

import PhotoLibraryIcon
from "@mui/icons-material/PhotoLibrary";

import ReviewsIcon
from "@mui/icons-material/Reviews";

const Sidebar = ({
  collapsed
}) => {

  const location =
    useLocation();

  // =========================
  // MENU
  // =========================

  const menu = [

    {
      name: "Dashboard",
      path: "/admin",
      icon: <DashboardIcon />
    },

    {
      name: "Products",
      path: "/admin/products",
      icon: <InventoryIcon />
    },

    {
      name: "Categories",
      path: "/admin/categories",
      icon: <CategoryIcon />
    },

    {
      name: "Orders",
      path: "/admin/orders",
      icon: <ShoppingCartIcon />
    },

    {
      name: "Users",
      path: "/admin/users",
      icon: <PeopleIcon />
    },
    {
      name: "Gallery",
      path: "/admin/gallery",
      icon: <PhotoLibraryIcon />
    },
    {
    name: "Customer Feedback",
    path: "/admin/feedback",
    icon: <ReviewsIcon />
  }

  ];

  return (

    <div style={styles.sidebar}>

      {/* LOGO */}

      <div style={styles.logoWrap}>

        <h2 style={styles.logo}>

          {collapsed
            ? "T"
            : "🔮 Tuli Admin"}

        </h2>

      </div>

      {/* MENU */}

      <div style={styles.menuWrap}>

        {menu.map((item) => {

          const active =
            location.pathname ===
            item.path;

          return (

            <Link
              key={item.path}
              to={item.path}
              style={{
                ...styles.link,

                background:
                  active
                    ? "#ff9800"
                    : "transparent",

                color:
                  active
                    ? "#fff"
                    : "#333"
              }}
            >

              <div style={styles.icon}>
                {item.icon}
              </div>

              {!collapsed && (

                <span style={styles.name}>
                  {item.name}
                </span>

              )}

            </Link>
          );
        })}
      </div>

    </div>
  );
};

export default Sidebar;

// =========================
// STYLES
// =========================

const styles = {

  sidebar: {
    height: "100vh",
    background: "#fff",
    borderRight:
      "1px solid #eee",
    padding: 15,
    display: "flex",
    flexDirection: "column"
  },

  logoWrap: {
    paddingBottom: 20,
    borderBottom:
      "1px solid #eee",
    marginBottom: 20
  },

  logo: {
    margin: 0,
    textAlign: "center",
    color: "#ff5722",
    fontSize: 24,
    fontWeight: "bold"
  },

  menuWrap: {
    display: "flex",
    flexDirection: "column",
    gap: 10
  },

  link: {
    display: "flex",
    alignItems: "center",
    padding: "12px 14px",
    borderRadius: 12,
    textDecoration: "none",
    transition: "0.3s"
  },

  icon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },

  name: {
    marginLeft: 12,
    fontWeight: "bold",
    fontSize: 15
  }
};